export default "__VITE_PUBLIC_ASSET__3ea4050e__"